module.exports = {
  QuickEntry: 'Быстрый доступ',
  LastRefreshTime: 'Посл. обновл. данных',
  SopBoard: 'SOP-доска',
  SeaExport: 'Морской экспорт',
  SeaImport: 'Морской импорт',
  AirExport: 'Авиаэкспорт',
  AirImport: 'Авиаимпорт',
  RailwayExport: 'Желдор. эксп.',
  RailwayImport: 'Желдор. имп.',
  IntegratedJob: 'Компл. лог.',
  BusinessVolumeGraph: 'График объема операций',
  PackUp: 'Свернуть',
  Unfold: 'Развернуть',
  SopReveal: 'Отображение SOP',
  SopFilterConditions: 'Условия фильтрации SOP',
  SaveSucceed: 'Сохранено успешно',
  QuickEntryPopover: {
    FirstLine: '1. Вы можете перетащить любую функцию из меню в быстрый доступ',
    SecondLine: '2. Если быстрых ссылок слишком много для одной строки, они автоматически переносятся.'
  },
  SopBoardPopover: {
    FirstLine: '1. SOP-панель отображает только доступные вам операции и выбранные узлы с состояниями.',
    SecondLine: '2. Операции со статусом "Завершено" больше не отображаются в этом узле.',
    ThirdLine: '3. При наведении курсора на узел отображаются выбранные статусы и количество операций.',
    FourthLine: '4. Клик по узлу или статусу перенаправит к соответствующей функции для поиска операций.'
  },
  LineChartPopover: {
    FirstLine: '1. График объема операций показывает только новые операции за последние 7 дней.'
  },
  SopFilterContent: {
    SopFilterConditionsTip: 'Операции учитываются в SOP-доске при соответствии любому из условий:',
    BusinessState: 'По статусу операции',
    Operation: 'В процессе',
    Submit: 'Отправлено',
    Audit: 'Проверено',
    Date: 'По дате операции',
    ETD: 'Дата операции (ETD) не ранее',
    ETA: 'Дата операции (ETA) не ранее',
    Days: 'дней назад',
    PleaseInputDays: 'Введите количество дней',
    PleaseSelectBusinessType: 'Выберите хотя бы один статус операции',
    PreCommit: 'Предварительная отправка'
  },
  QuickEntryLayer: {
    FirstLine: '1. Кликните для быстрого перехода к функции',
    SecondLine: '2. Можно перетащить функцию из меню в быстрый доступ'
  },
  SopBoardLayer: {
    FirstLine: '1. Здесь отображаются отслеживаемые SOP-узлы',
    SecondLine: '2. Наведите курсор на узел для просмотра количества операций по статусам',
    ThirdLine: '3. Отображаемые узлы и статусы настраиваются',
    FirstLine2: '1. Здесь отображаются отслеживаемые элементы доски',
    SecondLine2: '2. Клик по элементу отобразит соответствующие данные'
  },
  LineChartLayer: {
    FirstLine: '1. Здесь показано количество новых операций за 7 дней',
    SecondLine: '2. Доступна статистика по дате операции и дате создания'
  },
  SettingLayer: {
    FirstLine: 'Нажмите иконку шестеренки для настройки отображаемых узлов и статусов',
    SecondLine: 'Здесь указано время последнего обновления данных'
  },
  NextStep: 'Далее',
  Loading: 'Загрузка данных...',
  hasPermission: 'Извините, у вас нет доступа',
  warningMessage: 'Предупреждения',
  ignoreMessage: 'Игнорировать сообщение',
  ignoreSelected: 'Игнорировать выбранное',
  restoreSelected: 'Восстановить выбранное',
  ScreeningContent: 'Фильтровать содержимое:',
  Warning: 'Предупреждение',
  nodeName: 'Название узла',
  nodeState: 'Состояние узла',
  warningLevel: 'Уровень предупреждения',
  warningAt: 'Время предупреждения',
  warningContent: 'Содержание предупреждения',
  sift: 'Фильтр',
  toDoList: 'Список задач',
  SopWarning: 'SOP-предупреждение',
  DelTrackingDetailConfirm: 'Внимание: будут удалены связанные бизнес-детали и SOP-узлы',
  DelTrackingConfirm: 'Удалить этот узел? После удаления узла связанные бизнес-документы также будут синхронно удалены.',
  copyTrackingTemplateConfirm: 'Копировать шаблон 【{0}】?',
  SelectTheNode: 'Выбрать узел',
  StatusType: 'Тип состояния',
  AutomaticTriggering: 'Автоматический запуск',
  ExternalEncoding: 'Внешний код',
  ReportTemplate: 'Шаблон отчета',
  SendNotifications: 'Отправить уведомление',
  NotSendNotifications: 'Не отправлять уведомление',
  InitialState: 'Начальное состояние'
}
